'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var telephone = {
  bindings: {
    value: '@'
  },
  template: '<a href="tel:{{ $ctrl.value }}">{{ $ctrl.value }}</a>'
};

exports.default = telephone;


/** WEBPACK FOOTER **
 ** ./src/app/directives/common/telephone.js
 **/